import React, {useEffect, useState, Fragment} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import validator from 'validator';

import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Container,
  Paper, 
  Grid, 
  Dialog,
  DialogContent,
  Link,
  TextField,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { setFormDataAction, submitFormDataAction  } from 'redux/actions/getFormActions';
import logo from 'assets/logo.png';
import Form1 from './Form_1';
import Form2 from './Form_2';
import Form3 from './Form_3';
import Success from './success';

const useStyles = makeStyles((theme) => ({
  logo: {
      width: 250,
      height: 80
    },
}));

const steps = ['step1', 'step2', 'step3', 'step4'];

export default function ClaimForm() {

  const formData = useSelector(state => state.formData.data);
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(0);
  const [openDlg, setOpenDlg] = useState(false);
  const classes = useStyles();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(setFormDataAction({
      ...formData, 
      search_email:value, 
      search_email_valid: validator.isEmail(value)
    }));
  };

  const findLandlordId = () => {
    dispatch(submitFormDataAction({...formData, type: 'search'} ));
    setActiveStep(2);
    setOpenDlg(false);
  }

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleStepLabel = (index) => {
    if (index < activeStep) {
      setActiveStep(index);
    }
  }

  return (
    <Container >
      <Grid container justifyContent='center' alignItems="center">
        <Grid item md={activeStep === 6 ? 11 : 6} sx={{my: 4}}>
          <Paper sx={{bgcolor: '#f9f9f9'}}>
            <Grid container justifyContent="center" direction="column" padding={{xs:0, sm: 4}}>
                <Grid container justifyContent={'center'} sx={{my: 3}}>
                  <img src={logo} className={classes.logo}/>
                </Grid>
                <Typography variant="h4" color="primary" sx={{ mb: 1, textAlign: 'center' }}>
                  Client Onboarding
                </Typography>
                <Typography variant="h6" color="primary" sx={{ mb: 1, textAlign: 'center' }}>
                  Application for Insurance
                </Typography>
                {activeStep !== 2 &&
                  <Paper elevation={1} sx={{ textAlign: 'center', p:2, bgcolor: '#f9f9f9'}}>
                    <Grid container justifyContent="center">
                      <Typography color="primary" variant='h6'>Forgot your Leap LandlordID? <Link href="#" sx={{ml:2}} onClick={() => setOpenDlg(true) }>Click Here</Link></Typography>
                    </Grid>
                  </Paper>
                }
                <Box  sx={{ width: '100%', mt: 3}} >
                  <Grid container justifyContent="center">
                    <Grid item xs={11} md={6}>
                      <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => {
                          const stepProps = {};
                          const labelProps = {};
                          return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps} onClick={() => handleStepLabel(index)}></StepLabel>
                            </Step>
                          );
                        })}
                      </Stepper>
                    </Grid>
                  </Grid>
                    {activeStep === steps.length ? (
                      <Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                          All steps completed - you&apos;re finished
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                          <Box sx={{ flex: '1 1 auto' }} />
                          <Button onClick={handleReset}>Reset</Button>
                        </Box>
                      </Fragment>
                    ) : (
                      <Fragment>
                        {activeStep === 0 && <Form1 handleNext={handleNext} />}
                        {activeStep === 1 && <Form2 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 2 && <Form3 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 3 && <Success handleNext={handleNext} handleBack={handleBack} />}
                      </Fragment>
                    )}
                </Box>
            </Grid>
          </Paper>
          <Dialog
            open={openDlg}
            onClose={() => setOpenDlg(false)}
          >
            <DialogContent>
              <Grid container justifyContent="center" alignItems="center" spacing={3} >
                <Grid item>
                  <Typography color="primary" variant='h6'>Find Leap LandlordID by Email</Typography>
                </Grid>
                <Grid item>
                  <TextField
                    error={!formData.search_email || !formData.search_email_valid}
                    variant="standard"
                    color={formData.search_email ? "primary" : "error"}
                    required
                    value={formData.search_email}
                    onChange={(e) => handleChange(e)} 
                  />
                </Grid>
                <Grid item>
                  <Button 
                    onClick={() => findLandlordId()} 
                    variant="contained"
                    color="primary"
                    disabled={!formData.search_email_valid}
                  >
                      <Typography variant='body1' >
                          Find
                      </Typography>
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>
      </Grid>
    </Container>
  );
}
